<template>
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.99965 0C5.13226 0 5.25944 0.0526784 5.35321 0.146447C5.44698 0.240215 5.49965 0.367392 5.49965 0.5V12.293L8.64565 9.146C8.73954 9.05211 8.86688 8.99937 8.99965 8.99937C9.13243 8.99937 9.25977 9.05211 9.35365 9.146C9.44754 9.23989 9.50029 9.36722 9.50029 9.5C9.50029 9.63278 9.44754 9.76011 9.35365 9.854L5.35365 13.854C5.30721 13.9006 5.25203 13.9375 5.19129 13.9627C5.13054 13.9879 5.06542 14.0009 4.99965 14.0009C4.93389 14.0009 4.86877 13.9879 4.80802 13.9627C4.74728 13.9375 4.6921 13.9006 4.64565 13.854L0.645655 9.854C0.551768 9.76011 0.499023 9.63278 0.499023 9.5C0.499023 9.36722 0.551768 9.23989 0.645655 9.146C0.739542 9.05211 0.866879 8.99937 0.999655 8.99937C1.13243 8.99937 1.25977 9.05211 1.35366 9.146L4.49965 12.293V0.5C4.49965 0.367392 4.55233 0.240215 4.6461 0.146447C4.73987 0.0526784 4.86705 0 4.99965 0Z"
      fill="#A3A3A3"
    />
  </svg>
</template>
